// Feature flags — يتحكم بإظهار/إخفاء طبقات التجربة التفاعلية الجديدة.
//
// - في Production (rushcp-marketplace.emergent.host): كل الطبقات الجديدة مُخفاة.
// - في Preview (rushcp-marketplace.preview.emergentagent.com): مُفعّلة للمراجعة.
// - يمكن تجاوز القرار عبر localStorage:
//     localStorage.rushInteractive = "on" / "off"
// - أو عبر URL: ?interactive=on / ?interactive=off
//
// حين تُصبح كل الميزات جاهزة للنشر، غيّر PRODUCTION_HOSTS إلى مصفوفة فارغة
// أو اضبط ENABLE_ON_PRODUCTION = true.

const PRODUCTION_HOSTS = ["rushcp-marketplace.emergent.host"];
const ENABLE_ON_PRODUCTION = true;

const isBrowser = typeof window !== "undefined";

const readOverride = () => {
  if (!isBrowser) return null;
  // 1) URL param
  try {
    const p = new URLSearchParams(window.location.search).get("interactive");
    if (p === "on") return true;
    if (p === "off") return false;
  } catch {}
  // 2) localStorage
  try {
    const v = window.localStorage.getItem("rushInteractive");
    if (v === "on") return true;
    if (v === "off") return false;
  } catch {}
  return null;
};

const isProductionHost = () => {
  if (!isBrowser) return false;
  return PRODUCTION_HOSTS.includes(window.location.hostname);
};

export const isInteractiveLayerEnabled = () => {
  const override = readOverride();
  if (override !== null) return override;
  if (isProductionHost()) return ENABLE_ON_PRODUCTION;
  return true; // Preview / local dev
};
